/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';

import type { CustomGlyphProps } from '@atlaskit/icon/types';

export default (props: CustomGlyphProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.8246 0H2.17536C0.973942 0 0 0.973942 0 2.17536V21.8246C0 23.0261 0.973942 24 2.17536 24H21.8246C23.0261 24 24 23.0261 24 21.8246V2.17536C24 0.973942 23.0261 0 21.8246 0Z"
      fill="#FF3366"
    />
    <path
      d="M8.02079 7.55134C8.30423 7.54623 8.57986 7.45758 8.81313 7.29649C9.0464 7.1354 9.22693 6.90904 9.3321 6.64579C9.43727 6.38253 9.4624 6.09409 9.40433 5.81661C9.34626 5.53914 9.20759 5.28497 9.00568 5.08598C8.80378 4.88698 8.54763 4.75201 8.26934 4.69797C7.99105 4.64394 7.703 4.67324 7.4413 4.78222C7.17959 4.8912 6.95588 5.075 6.79819 5.31058C6.64051 5.54617 6.55586 5.82305 6.55487 6.10654C6.55549 6.29788 6.59399 6.4872 6.66814 6.66359C6.74229 6.83998 6.85063 6.99995 6.98691 7.13426C7.12318 7.26858 7.2847 7.37458 7.46215 7.44616C7.6396 7.51775 7.82946 7.55349 8.02079 7.55134Z"
      fill="white"
    />
    <path
      d="M4.98047 15.287C4.89741 15.6431 4.85394 16.0072 4.85087 16.3728C4.85087 17.6448 5.54111 18.4896 7.00703 18.4896C8.22335 18.4896 9.20927 17.7677 9.91871 16.6013L9.48575 18.3408H11.904L13.2835 12.8064C13.6282 11.4048 14.2963 10.6771 15.3101 10.6771C16.1078 10.6771 16.6042 11.1734 16.6042 11.9923C16.6066 12.255 16.5691 12.5166 16.4928 12.768L15.7814 15.312C15.68 15.6623 15.6293 16.0254 15.6307 16.3901C15.6307 17.5977 16.3421 18.4809 17.8301 18.4809C19.1021 18.4809 20.1158 17.6621 20.6765 15.6969L19.728 15.3312C19.2537 16.6454 18.8438 16.8835 18.5203 16.8835C18.1968 16.8835 18.024 16.6685 18.024 16.2374C18.033 16.0099 18.0691 15.7844 18.1315 15.5654L18.8217 13.0867C18.9765 12.5788 19.0564 12.051 19.0589 11.52C19.0589 9.66623 17.9376 8.69855 16.5792 8.69855C15.3072 8.69855 14.0131 9.85055 13.367 11.0534L13.8413 8.88575H10.1549L9.63743 10.7952H11.3654L10.3037 15.048C9.46943 16.9017 7.93727 16.9325 7.74527 16.8893C7.42943 16.8182 7.22783 16.6973 7.22783 16.2883C7.23732 15.9544 7.28794 15.6229 7.37855 15.3014L8.99135 8.88671H4.89599L4.37759 10.7952H6.08063L4.98047 15.287Z"
      fill="white"
    />
  </svg>
);
